import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { CTAZod } from '@/types/CTAType';
import { getColumnNameValues } from '@/enum/ColumnName';
import { AddresseZod } from '@/types/AddresseType';
import { SocialMediaZod } from '@/types/SocialMediaType';
import { TitleZod } from '@/types/TitleType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const FooterMenuZod = z.object({
  id: z.number(),
  label: z.string().nullable(),
  columns: z.enum(getColumnNameValues()),
  links: z.array(CTAZod).nullable(),
});

const FooterZod = z.object({
  id: z.number(),
  documentId: z.string(),
  groups: z.array(FooterMenuZod).nullable(),
  description: z.string(),
  phone: z.string().nullable(),
  mail: z.string().nullable(),
  addresses: z.array(AddresseZod).nullable(),
  socialMedia: z.array(SocialMediaZod).nullable(),
  preFooter: z.object({
    title: TitleZod,
    paragraph: ParagraphZod,
    cta: CTAZod.nullable(),
    doudou: MediaZod,
  }),
  partners: z.array(
    z.object({
      id: z.number(),
      logo: MediaZod,
      link: z.string(),
    }),
  ),
  legalLinks: z.array(CTAZod).nullable(),
  copyright: z.string(),
  logo: MediaZod,
});

export { FooterZod, FooterMenuZod };
export type FooterType = z.infer<typeof FooterZod>;
export type FooterMenuType = z.infer<typeof FooterMenuZod>;
